import { render } from "./ActionHotspot.vue?vue&type=template&id=4ef75fd5&ts=true"
import script from "./ActionHotspot.vue?vue&type=script&lang=ts"
export * from "./ActionHotspot.vue?vue&type=script&lang=ts"

import "./ActionHotspot.vue?vue&type=style&index=0&id=4ef75fd5&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__